import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";

const CustomDesign = () => {
  return (
    <section className="custom-design ">
      <Container fluid className="showcase-container ">
        {/* <div className="khan_custome_design_section"> */}
        <Row className="w-100 m-auto khan_custome_design_section">
          <Col md={{span:6, offset:6}} lg={{span:6, offset:6}} xs={12} sm={12}>
          <div>
          <Heading className="text-center">
              <h2> Customize Your Design  </h2>
              <p>
              Design your own {Je_welryspelling} with the help of our
              experienced {Je_welryspelling} Designs artisans
              
              </p>
            </Heading>

            <div className="text-center">
              <Link to="/custom-design" className="btn outline-base-btn large ">
                Get Started
              </Link>
            </div>
          </div>


            
          </Col>
        </Row>
        {/* </div> */}
     
      </Container>
    </section>
  );
};

export default CustomDesign;
